<template>
    <v-flex>
        <v-checkbox :disabled="true" color="primary" v-model="selectTopicHeader" hide-details></v-checkbox>
        <span class="select-topics__title">{{topic.topicName}}</span>
    </v-flex>
</template>

<script>

    export default {
        props: {
            topic: {
                type: Object,
                required: true,
            },
        },
        computed: {
            selectTopicHeader: {
                get() {
                    return this.topic.selectedTopics.length > 0;
                },
                set() {
                },
            },
        },
    };
</script>
